import { useState, useEffect } from 'react';

/**
 * Hook for responsive breakpoint detection
 * @param {string} query - CSS media query string
 * @returns {boolean} - Whether the media query matches
 */
export const useMediaQuery = (query) => {
    const [matches, setMatches] = useState(() => {
        if (typeof window !== 'undefined') {
            return window.matchMedia(query).matches;
        }
        return false;
    });

    useEffect(() => {
        if (typeof window === 'undefined') return;

        const mediaQuery = window.matchMedia(query);
        const handler = (e) => setMatches(e.matches);

        // Set initial value
        setMatches(mediaQuery.matches);

        // Listen for changes
        mediaQuery.addEventListener('change', handler);
        return () => mediaQuery.removeEventListener('change', handler);
    }, [query]);

    return matches;
};

// Convenience hooks for common breakpoints
export const useIsDesktop = () => useMediaQuery('(min-width: 1025px)');
export const useIsMobile = () => useMediaQuery('(max-width: 1024px)');
